module.exports = __webpack_public_path__ + "static/homepage-wireframe-initial-4eddfa75653c9949abafca847fc6dc6f.png";